import httpClient from '../../services/http-client';
import { API_SUB_URL_SYSTEM_SETTING } from '../../constants';
import { fetchDataRequest, fetchDataSuccess, fetchDataError } from '../actions';
import { 
    FETCH_DATA_REQUEST, FETCH_DATA_ERROR,
    LOAD_A_SYSTEM_SETTING, ADD_NEW_SYSTEM_SETTING, UPDATE_A_SYSTEM_SETTING, DELETE_A_SYSTEM_SETTING
} from '../actionTypes';

export const apiLoadASystemSetting = ({ id }) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.get(`${API_SUB_URL_SYSTEM_SETTING}/${id}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_A_SYSTEM_SETTING, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiLoadASystemSettingByCompanyId = ({ company_id }) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.get(`${API_SUB_URL_SYSTEM_SETTING}/company_id/${company_id}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_A_SYSTEM_SETTING, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiCreateNewSystemSetting = (payload) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.post(API_SUB_URL_SYSTEM_SETTING, payload)
            .then(response => {
                dispatch(fetchDataSuccess(ADD_NEW_SYSTEM_SETTING, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiUpdateASystemSetting = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.put(`${API_SUB_URL_SYSTEM_SETTING}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(UPDATE_A_SYSTEM_SETTING, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiDeleteASystemSetting = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.delete(`${API_SUB_URL_SYSTEM_SETTING}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(DELETE_A_SYSTEM_SETTING, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};